<div class="footer-area">
    <div class="at-link-contact">
        <div class="link-contact">
            <h2 i18n="Title CallToAction|Title for Call-To-Action@@CallToAction">Have a great idea for an app? Need a website?</h2>
            <span i18n="Subtitle CallToAction|Subtitle for Call-To-Action@@subCallToAction">Click below and get in touch!</span>
            <div class="contactme">
               <a routerLink="/contact" class="btn btn-contact" i18n="Label Contact Me|Label for Contact Me button@@CallToActionButton">Contact me!</a> 
            </div>
        </div>
    </div>
    <footer class="at-footer">
          <ul class="social clearfix">
            <li><a class="facebook" href="https://www.facebook.com/airtontoyansk" target="_blank"></a></li>
            <li><a class="github" href="https://github.com/atoyansk" target="_blank"></a></li>
            <li><a class="linkedin" href="https://www.linkedin.com/in/airtontoyansk/" target="_blank"></a></li>
          </ul>
          <nav class="navbar navbar-expand-lg">
            <ul class="navbar-nav">  
                <li><a routerLink="/home" routerLinkActive="active"     i18n="Nav Home|Label for Nav Home@@NavHome">Home</a></li>
                <li><a routerLink="/about" routerLinkActive="active"    i18n="Nav About|Label for Nav About@@NavAbout">About me</a></li>
                <li><a routerLink="/services" routerLinkActive="active" i18n="Nav Services|Label for Nav Services@@NavServices">Services</a></li>
                <li><a routerLink="/contact" routerLinkActive="active"  i18n="Nav Contact|Label for Nav Contact@@NavContact">Contact me</a></li>
                <li><a routerLink="/admin" routerLinkActive="active">Admin</a></li>
            </ul> 
          </nav>
          
          <p i18n="Copyright|Label for Copyright@@Copyright">© {{year}} - Airton Toyansk Portfolio</p>
          <div class="lang-mob">
              <a href="{{hashLoc}}" target="_self" id="lang"> | {{locCode}} | </a>
          </div>
    </footer>
</div>

